import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './SenderDetails.css';
import './SendersList.css';
import './SenderPhotoUpload.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import moment from "moment";
import SenderSubDetails from "./SenderSubDetails";
import { store } from "../../redux/store";
import { selectedBeneList, setBankDetails, setBranchAddress, setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
import { setSendersListDetails, selectedSender, setSelectedBankId } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import { Link } from "react-router-dom";
const httpClient = axios.create();

class SenderDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			errorMessage: ''
		}
	}

	print = (event) => {
		event.preventDefault();
		window.print();
	}
	componentDidMount() {

	}
	componentWillUnmount() {
	}




	getSenderDetils = (event, mobileNo) => {

		event.preventDefault();
		this.setState({
			showSenderVisible: false
		})
		store.dispatch(setSendersListDetails(''));

		var allsenderuRL = '/api/v1/dmt/customer/details/' + mobileNo;
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		httpClient.get(allsenderuRL, { headers }
		).then((response) => {
			console.log('selected sender response' + JSON.stringify(response.data));
			console.log(response.data.response.msg);
			if (response.data.response.msg == 'SUCCESS') {


				store.dispatch(selectedSender(response.data));
				store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

				store.dispatch(setSelectedBankName(''));
				store.dispatch(setIfscCode(''));
				store.dispatch(setBranchAddress(''));
				store.dispatch(setSelectedBankId(''));

				var addBeneBtn = document.getElementById('addBeneBtn');
				addBeneBtn.click();
			} else {
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {

			this.errorMessageCall(error.msg);
			if(error.message.includes("401")){
				tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
			}else{
				
			}
		});
	}


	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}

	addbeneficiary = (event) => {

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		var bankDetailsUrl = '/api/v1/catalog/bank/all/summary';
		httpClient.get(bankDetailsUrl, { headers }
		).then((response) => {
			console.log('all bank details' + JSON.stringify(response.data));
			if (response.data.length > 0) {
				this.setState({
					bankDetails: response.data
				})
				store.dispatch(setBankDetails(response.data));
				this.getSenderDetils(event, this.props.addsenderRequest.customer.mobile);

			}
		}
		).catch(error => {
		
			if(error.message.includes("401")){
				tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
			}else{
				
			}
		});
	}




	render() {

		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">



							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Sender Details</h3>
												<div class="headbtn">




													<Link to='/dmt'>
														<button class="dbbtn"
															type="button">Home</button>
													</Link>

													<Link to='/add-beneficiary'>
														<button id='addBeneBtn' hidden={true}></button>
													</Link>

												</div>
											</div>



											<div class="status">
												<h3 class="success">Sender has been added successfully!</h3>
											</div>
											<SenderSubDetails />

											{/* <div class="txn-btn">
												<button type="button" class="print" onClick={this.print}>Print</button>
												<button type="button" class="help" onClick={this.help}></button>
											</div> */}

											<button type="button" class="btn btn-primary"
												onClick={this.addbeneficiary} >Add Beneficiary</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, customerId, addsenderRequest,
			agentInfo, token, clientRole,callBackUrl } }
) => ({
	errorMessage, loginErrorMessage, phone, customerId, addsenderRequest,
	agentInfo, token, clientRole,callBackUrl
});

export default connect(mapStateToProps, null)(SenderDetails);
